/**
 * BioBlue horizontal track scroll (Reviews, Benefits, Personas, How it works steps).
 * Inline onclick handlers expect these on the global object.
 */
window.bbCarouselNext = function (id) {
  var track = document.getElementById(id);
  if (!track) return;
  var card = track.querySelector(
    '.bb-review-card, .bb-personas__card, .bb-benefits__card, .bb-step-card, .bb-hiw-supp__card, [class*="__card"]'
  );
  if (!card) return;
  var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 24;
  track.scrollBy({ left: card.offsetWidth + gap, behavior: 'smooth' });
};

window.bbCarouselPrev = function (id) {
  var track = document.getElementById(id);
  if (!track) return;
  var card = track.querySelector(
    '.bb-review-card, .bb-personas__card, .bb-benefits__card, .bb-step-card, .bb-hiw-supp__card, [class*="__card"]'
  );
  if (!card) return;
  var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 24;
  track.scrollBy({ left: -(card.offsetWidth + gap), behavior: 'smooth' });
};
